var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeChannel
    ? _c("Chat", {
        attrs: {
          network: _vm.activeChannel.network,
          channel: _vm.activeChannel.channel,
          focused: _vm.$route.query.focused,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }